import { useRef, useState } from "react";
import Dialog from "components/Overlays/ResponsiveDialog";
import { FiTrash2 } from "react-icons/fi";
import useDeleteShippingAddress from "api/AddressResource/useDeleteShippingAddress";

const DeleteShippingAddress = ({ addressId, nickname }) => {
	const { mutateAsync, isLoading } = useDeleteShippingAddress(addressId);
	const [visible, setVisible] = useState(false);
	const trigger = useRef(null);
	const close = () => {
		if (!isLoading) {
			setVisible(false);
			trigger.current?.focus();
		}
	};
	return (
		<>
			<button
				ref={trigger}
				type="button"
				className="account-icon-button danger"
				aria-label={`Remove ${nickname || "delivery address"}`}
				disabled={isLoading}
				onClick={() => setVisible(true)}
			>
				<FiTrash2 aria-hidden="true" />
			</button>
			<Dialog
      sheet={false}
				header="Remove this address?"
				visible={visible}
				onHide={close}
				className="account-dialog"
				maskClassName="account-dialog-mask"
				draggable={false}
				resizable={false}
				blockScroll
				closable={!isLoading}
				closeOnEscape={!isLoading}
				ariaCloseIconLabel="Keep delivery address"
				footer={
					<div className="account-dialog-footer">
						<button
							type="button"
							className="account-button secondary"
							disabled={isLoading}
							onClick={close}
						>
							Keep address
						</button>
						<button
							type="button"
							className="account-button danger"
							disabled={isLoading}
							onClick={async () => {
								try {
									await mutateAsync();
									setVisible(false);
								} catch (_) {
									/* The mutation displays errors. */
								}
							}}
						>
							{isLoading ? "Removing…" : "Remove address"}
						</button>
					</div>
				}
			>
				<p className="account-dialog-copy">
					{nickname ? `“${nickname}”` : "This address"} will be removed from your saved delivery
					addresses. Your previous orders won’t be affected.
				</p>
			</Dialog>
		</>
	);
};
export default DeleteShippingAddress;
